// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__D9Cn5","header":"PatientBlock_header__2yu4Z","label":"PatientBlock_label__2dwda","option":"PatientBlock_option__d0Ua4"};